import { ApiCacheTags, baseApiService } from '@qapline/api';
import { getConfig } from '@qapline/config';

import { TGeocodedAddress, TGetReverseGeocodedAddressRequestBody } from '../types';

const { forward: forwardEndpoint, reverse: reverseEndpoint } = getConfig().api.endpoints.geocoding;
const { address: addressTag, reverseAddress: reverseAddressTag } = ApiCacheTags.geocoding;

export const geocodingApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getGeocodedAddress: builder.query<TGeocodedAddress[], string>({
            query: (searchTerm) => ({
                url: forwardEndpoint,
                method: 'GET',
                params: {
                    search: searchTerm,
                },
            }),
            providesTags: (_result, error, args) => (error ? [] : [{ type: addressTag, id: args }]),
        }),
        getReverseGeocodedAddress: builder.query<TGeocodedAddress[], TGetReverseGeocodedAddressRequestBody>({
            query: ({ latitude, longitude }) => ({
                url: reverseEndpoint,
                method: 'GET',
                params: {
                    latitude,
                    longitude,
                },
            }),
            providesTags: (_result, error, args) =>
                error ? [] : [{ type: reverseAddressTag, id: JSON.stringify(args) }],
        }),
    }),
});

export const {
    useGetGeocodedAddressQuery,
    useLazyGetGeocodedAddressQuery,
    useGetReverseGeocodedAddressQuery,
    useLazyGetReverseGeocodedAddressQuery,
} = geocodingApi;
